import * as proj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import Zoom from 'ol/control/Zoom';
import Attribution from 'ol/control/Attribution';
import DragPan from 'ol/interaction/DragPan';
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom';
import PinchZoom from 'ol/interaction/PinchZoom';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import DragZoom from 'ol/interaction/DragZoom';
import KeyboardPan from 'ol/interaction/KeyboardPan';
import KeyboardZoom from 'ol/interaction/KeyboardZoom';
import Modify from 'ol/interaction/Modify';
import Point from 'ol/geom/Point';
import Control from 'ol/control/Control';
import { defaults as controlDefaults } from 'ol/control';
import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';
import Collection from 'ol/Collection';
import Feature from 'ol/Feature';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import PointGeom from 'ol/geom/Point';
import Icon from 'ol/style/Icon';
import Style from 'ol/style/Style';
import Projection from 'ol/proj/Projection';
import { getCenter } from 'ol/extent';
import * as extent from 'ol/extent';
import { Overlay, View, Map } from 'ol';
import { Fill, Stroke, Text } from 'ol/style';
import TileGrid from 'ol/tilegrid/TileGrid';

export {
	Collection,
	Feature,
	VectorLayer,
	VectorSource,
	PointGeom,
	Icon,
	Style,
	Projection,
	TileLayer,
	XYZ,
	Zoom,
	Attribution,
	DragPan,
	DoubleClickZoom,
	PinchZoom,
	MouseWheelZoom,
	DragZoom,
	KeyboardPan,
	KeyboardZoom,
	Modify,
	Point,
	Control,
	controlDefaults,
	proj,
	extent,
	MousePosition,
	createStringXY,
	getCenter,
	View,
	Overlay,
	Stroke,
	Fill,
	Text,
	Map
	,
	TileGrid
};



// WEBPACK FOOTER //
// ./src/ts/openlayers/ol-bridge.ts